import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { setItem } from '@app/actions/item.action';
import { setShowOverlayLoading } from '@app/actions/overlay-loading.action';
import { countPdtWishList, loadPdtWishList } from '@app/actions/shoppingmall/wishlist-pdt.action';
import { setWAlert } from '@app/actions/w-alert.action';
import { ActionConstant } from '@app/common/constant/action-constant';
import { LenConstant } from '@app/common/constant/len.constant';
import { MessageConstant } from '@app/common/constant/message.constant';
import { WAlertConstant } from '@app/common/constant/w-alert-icon.constant';
import { AuthUtil } from '@app/common/util/auth.util';
import { ConvertUtil } from '@app/common/util/convert.util';
import { ValidationUtil } from '@app/common/util/validation.util';
import { SelectDropdownModel } from '@app/models/components/select-dropdown.model';
import { OrdPdtModel } from '@app/models/shoppingmall/order-pdt.model';
import { SmWownetModel } from '@app/models/system/sm-wownet.model';
import { itemState } from '@app/selectors/item.selector';
import { OverlayLoadingState } from '@app/selectors/overlay-loading.selector';
import { getPdtWishList, getTotalPdtWishList, PdtWishListState } from '@app/selectors/shoppingmall/wishlist-pdt-selector';
import { getSmWownet, SmWownetState } from '@app/selectors/system/sm-wownet.selector';
import { WAlertState } from '@app/selectors/w-alert.selector';
import { environment } from '@enviroments/environment';
import { Store } from '@ngrx/store';
import { DeviceDetectorService } from 'ngx-device-detector';
import { PaginationInstance } from 'ngx-pagination';
import { Observable, skip, Subscription } from 'rxjs';

@Component({
  selector: 'app-wish-list-pdt',
  templateUrl: './wish-list-pdt.component.html',
  styleUrls: ['./wish-list-pdt.component.css']
})
export class WishListPdtComponent implements OnInit, OnDestroy {
  smWownet$ = new Observable<SmWownetModel>();

  products$ = new Observable<OrdPdtModel[]>();
  products: OrdPdtModel[] = [];

  total$ = new Observable<number>();
  total: number = 0;

  subscription$ = {} as Subscription

  sortCd: string = "";
  pathKind: string = "PC";
  urlWownet: string = "";
  lshowPdtYn: string = "";
  key: string = "";

  lenOptions: SelectDropdownModel[] = LenConstant.listPdtLen;;
  lenSelected = this.lenOptions[0];

  page: number = 1;
  len: number = 12;
  totalPage : number = 0;

  isLogin: boolean = AuthUtil.isLogined();
  
  config: PaginationInstance = {
    id: "main-products",
    itemsPerPage: this.len,
    currentPage: this.page,
    totalItems: this.total,
  }

  constructor(private _overlayLoadingStore: Store<OverlayLoadingState>,
              private _pdtWishListStore: Store<PdtWishListState>,
              private _smWownetStore: Store<SmWownetState>,
              private _deviceService: DeviceDetectorService) { 
    this.smWownet$ = this._smWownetStore.select(getSmWownet);
    this.total$ = this._pdtWishListStore.select(getTotalPdtWishList);
    this.products$ = this._pdtWishListStore.select(getPdtWishList);
  }

  ngOnInit(): void {
    this.pathKind = this._deviceService.isDesktop()? 'PC' : 'PHONE';

    this._overlayLoadingStore.dispatch(setShowOverlayLoading({ loading: true }));

    this.subscription$ = this.smWownet$.subscribe(res => {
      if(ValidationUtil.isNotNullAndNotEmpty(res)) {
        this.urlWownet = ConvertUtil.convertToSring(res.urlWownet);
        this.lshowPdtYn = ConvertUtil.convertToSring(res.lShowPdtYn);
      }
    });

    this.loadProducts();
    this.loadTotalProduct();
    this.page = 1;
    this.config.currentPage = 1;

    this.total$.pipe(skip(1)).subscribe(res => {      
      this.total = res;
      this._pdtWishListStore.dispatch(setShowOverlayLoading({ loading: false }));
    });

    this.products$.pipe(skip(1)).subscribe(res => {
      this.products = res;
      this._pdtWishListStore.dispatch(setShowOverlayLoading({ loading: false }));
    });
  }

  ngOnDestroy(): void {
    let hasValue = this.subscription$.closed != undefined
    if(this.subscription$ && hasValue){
      this.subscription$.unsubscribe()
    }
  }

  loadTotalProduct(): void {
    const params = this.getParams();

    if (params.page < 0) return;
    
    this._overlayLoadingStore.dispatch(setShowOverlayLoading({ loading: true }));
    this._pdtWishListStore.dispatch(countPdtWishList({ params: params }));
  }

  loadProducts(): void {
    const params = this.getParams();

    if (params.page < 0) return;

    this._overlayLoadingStore.dispatch(setShowOverlayLoading({ loading: true }));
    this._pdtWishListStore.dispatch(loadPdtWishList({ params: params }));
  }

  handleOnChangePage(page: number): void {
    this.page = page;
    this.config.currentPage = page;
    
    this.loadProducts();
  }

  getParams(): any {
    let member = AuthUtil.getLoginedInfo();
    let userid = '';
    if (member) {
      userid = ConvertUtil.convertToSring(member.userid);
    }

    const params = {
      comId: environment.comId,
      cateCd: "",
      pathKind: this.pathKind,
      key: this.key,
      page: this.page - 1,
      len: this.len,
      userid: userid
    }

    return params;
  }

  handleOnTotalPage(totalPage: number): void {
    this.totalPage = totalPage;
  }
}
